import React from 'react';
import { Link } from 'react-router-dom';
import { SmartphoneIcon, CodeIcon, CpuIcon, DatabaseIcon, ServerIcon, HardDriveIcon, ArrowRightIcon } from 'lucide-react';
const services = [{
  icon: SmartphoneIcon,
  title: 'Mobile App Development',
  description: 'Native iOS and Android applications built for performance, reliability, and seamless user experiences across devices.',
  path: '/services/mobile-apps'
}, {
  icon: CodeIcon,
  title: 'Custom Web Development',
  description: 'Full-stack web applications engineered for performance, security, and scalability — from dashboards to enterprise platforms.',
  path: '/services/web-development'
}, {
  icon: CpuIcon,
  title: 'Embedded Systems',
  description: 'Software for embedded systems, industrial equipment, and specialized hardware with real-time operating system expertise.',
  path: '/services/embedded-systems'
}, {
  icon: DatabaseIcon,
  title: 'Database Solutions',
  description: 'Data migrations, import/export tools, and database optimization from legacy extraction to modern architecture design.',
  path: '/services/database-solutions'
}, {
  icon: ServerIcon,
  title: 'High Availability Infrastructure',
  description: 'Clustering, load balancing, and failover solutions that keep your critical systems running 24/7.',
  path: '/services/high-availability'
}, {
  icon: HardDriveIcon,
  title: 'Global File System',
  description: 'Distributed file system solutions for synchronized access across multiple servers and locations.',
  path: '/services/global-file-system'
}];
export function ServicesGrid() {
  return <section className="py-20 bg-background texture-light" data-id="element-576">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-577">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 scroll-fade-in-up" data-id="element-578">
          {services.map(service => {
          const Icon = service.icon;
          return <Link key={service.path} to={service.path} className="group block card-premium border border-border rounded-xl p-6 hover:border-accent hover:shadow-lg transition-all duration-300" data-id="element-579">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-4 border border-border bg-gradient-to-br from-background to-blue-50/50" data-id="element-580">
                  <Icon className="w-6 h-6 text-accent" data-id="element-581" />
                </div>
                <h2 className="text-lg lg:text-xl font-bold text-ink mb-2 group-hover:text-accent transition-colors truncate" data-id="element-582">
                  {service.title}
                </h2>
                <p className="text-muted text-sm leading-relaxed mb-4" data-id="element-583">
                  {service.description}
                </p>
                <span className="inline-flex items-center text-sm font-semibold text-accent gap-1 group-hover:gap-2 transition-all" data-id="element-584">
                  Learn More <ArrowRightIcon className="w-4 h-4" data-id="element-585" />
                </span>
              </Link>;
        })}
        </div>

        <div className="mt-16 max-w-3xl mx-auto text-center scroll-fade-in-up" data-id="element-586">
          <p className="text-lg text-muted leading-relaxed" data-id="element-587">
            Every project we take on is unique, and so is our approach. We work
            closely with each client to understand their specific challenges,
            then architect and build custom solutions that integrate seamlessly
            into their existing workflows. Whether you need a customer-facing
            application, an internal tool, or a complex system integration, our
            senior engineering team delivers production-ready software built for
            long-term reliability and scale.
          </p>
        </div>
      </div>
    </section>;
}